// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.web.user.property.listings.accountview.zrm.service.RentalManagerAccountViewZrmPropertiesService.AccountViewPropertyUnitStatus

export enum AccountViewPropertyUnitStatus {
  LEASED = 'LEASED',
  LEASED_AND_LISTED_FOR_RENT = 'LEASED_AND_LISTED_FOR_RENT',
  LISTED_FOR_RENT = 'LISTED_FOR_RENT',
  VACANT = 'VACANT',
}

export const AccountViewPropertyUnitStatus_values = [
  AccountViewPropertyUnitStatus.LEASED,
  AccountViewPropertyUnitStatus.LEASED_AND_LISTED_FOR_RENT,
  AccountViewPropertyUnitStatus.LISTED_FOR_RENT,
  AccountViewPropertyUnitStatus.VACANT,
] as const;
